import { Statistic } from 'antd';
import { ContainerCard } from './styles';

interface IStatisticCardProps {
  title: string;
  value: number | string;
  color: string;
  icon: React.ReactNode;
}

export const AStatisticCard: React.FC<IStatisticCardProps> = ({
  title,
  value,
  color,
  icon,
}) => {
  return (
    <ContainerCard>
      <Statistic
        title={title}
        value={value}
        precision={2}
        valueStyle={{ color, width: 200 }}
        suffix={icon}
      />
    </ContainerCard>
  );
};
